<mat-dialog-content>
  <div class="mat-dialog-body">
    <div class="mat-dialog-body-inner compliant-actions-dialog">
      <div class="text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="109.998" height="109.998" viewBox="0 0 109.998 109.998">
          <g id="Group_50582" data-name="Group 50582" transform="translate(0 0)">
            <g id="Group_50578" data-name="Group 50578" transform="translate(17.459 0)">
              <path id="Path_109359" data-name="Path 109359"
                d="M171.549.054,83.668,21.724a3.156,3.156,0,0,0-1.234,5.514l18.383,14.929a3.153,3.153,0,0,1,.912,1.216l38.862-18.344L172.921.261a1.8,1.8,0,0,0-1.371-.206Z"
                transform="translate(-81.266 0)" fill="#ffe28f" />
              <path id="Path_109360" data-name="Path 109360"
                d="M243.841,1.213,172.65,44.335a3.154,3.154,0,0,1,.25,1.4l-1.3,24.507a3.143,3.143,0,0,0,.931,2.41l49.529-41.666L244.174,1.47a1.844,1.844,0,0,0-.333-.257Z"
                transform="translate(-152.186 -0.952)" fill="#ffc263" />
              <path id="Path_109361" data-name="Path 109361"
                d="M317.264,74.562a3.153,3.153,0,0,1,1.22.93l14.53,18.243a3.156,3.156,0,0,0,5.541-1.243l20.5-87.075a1.8,1.8,0,0,0-.219-1.367l-22.4,29.165Z"
                transform="translate(-266.562 -3.18)" fill="#ffc263" />
              <path id="Path_109362" data-name="Path 109362"
                d="M247.594,2.411,175.948,73.595a3.142,3.142,0,0,0,2.4.909l26.539-1.483a3.151,3.151,0,0,1,1.425.255L247.876,2.763a1.848,1.848,0,0,0-.283-.352Z"
                transform="translate(-155.607 -1.893)" fill="#ffa85a" />
            </g>
            <g id="Group_50580" data-name="Group 50580" transform="translate(0 63.879)">
              <g id="Group_50579" data-name="Group 50579" transform="translate(0)">
                <path id="Path_109363" data-name="Path 109363"
                  d="M3.222,325.664a3.223,3.223,0,0,1-2.274-5.506L22.93,298.272a3.223,3.223,0,0,1,4.548,4.567L5.5,324.725A3.213,3.213,0,0,1,3.222,325.664Z"
                  transform="translate(0 -297.333)" fill="#c9f7f6" />
              </g>
            </g>
            <path id="Path_109364" data-name="Path 109364"
              d="M40.576,381.773,23.59,398.688a3.223,3.223,0,0,0-.009,4.557L35.7,394.407l9.433-12.625A3.222,3.222,0,0,0,40.576,381.773Z"
              transform="translate(-17.778 -299.015)" fill="#c9f7f6" />
            <g id="Group_50581" data-name="Group 50581" transform="translate(17.923 81.667)">
              <path id="Path_109365" data-name="Path 109365"
                d="M86.647,408.46a3.223,3.223,0,0,1-2.274-5.506l21.982-21.886a3.223,3.223,0,0,1,4.548,4.568L88.921,407.521A3.212,3.212,0,0,1,86.647,408.46Z"
                transform="translate(-83.425 -380.129)" fill="#8beae7" />
            </g>
            <path id="Path_109366" data-name="Path 109366"
              d="M29.3,407.509a3.213,3.213,0,0,0,2.274-.939l16.985-16.916a3.223,3.223,0,0,0,.009-4.557c-.015-.015-.031-.027-.046-.042L27.015,406.561a3.212,3.212,0,0,0,2.283.949Z"
              transform="translate(-21.211 -302.33)" fill="#8beae7" />
          </g>
        </svg>
        <h3 class="title">
          {{ 'fraudTasks.publishFraudCase' | translate}}
        </h3>
        <p class="sub-title">
          {{ 'fraudTasks.fraudCaseNamePlaceholder' | translate}}
        </p>
      </div>
      <form [formGroup]="formGroup">
        <div class="fields-group">
          <mat-form-field class="mb-2">
            <mat-label>{{ 'forms.publicFraudCaseName' | translate}}</mat-label>
            <input matInput formControlName="publicFraudCaseName" minlength="2" maxlength="150" />
            <mat-error *ngIf="hasError('publicFraudCaseName', 'maxlength')">
              {{"forms.maxLengthIsCharacters"|translate:{num:150} }}
            </mat-error>
            <mat-error *ngIf="hasError('publicFraudCaseName', 'minlength')">
              {{ 'forms.minLengthIsCharacters' | translate : {num:2} }}
            </mat-error>
            <mat-error *ngIf="hasError('publicFraudCaseName', 'required')">
              {{ 'forms.pleaseEnterFraudCaseName' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="actions text-center">
          <button (click)="saveRecord()" mat-raised-button [disabled]="loading" color="primary"
            [class.loading]="loading">
            {{ "fraudTasks.publishCase" | translate }}
          </button>
          <button mat-button type="button" [disabled]="loading" matDialogClose class="btn-grey ml-3">
            {{ "forms.Cancel" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>